var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { Text, TEXT_VIEW } from "../Text";
import { View, INDENT } from "../View";
import { BASE_BORDER_WIDTH, BASE_FONT_BOLD_WEIGHT, BASE_FONT_FAMILY, FONT_LINE_HEIGHT_M, FONT_SIZE_M, SPACING_M } from "../helpers";
export var TabPanelTitle = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: 12px ", ";\n\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    flex-shrink: 0;\n\n    display: flex;\n    flex-direction: column;\n    align-content: stretch;\n\n    ", "\n"], ["\n    padding: 12px ", ";\n\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    flex-shrink: 0;\n\n    display: flex;\n    flex-direction: column;\n    align-content: stretch;\n\n    ",
    "\n"])), SPACING_M, BASE_FONT_FAMILY, FONT_SIZE_M, BASE_FONT_BOLD_WEIGHT, FONT_LINE_HEIGHT_M, function (_a) {
    var theme = _a.theme;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        color: ", ";\n        border-bottom: ", " solid ", ";\n    "], ["\n        color: ", ";\n        border-bottom: ", " solid ", ";\n    "])), theme.colorTextMain, BASE_BORDER_WIDTH, theme.colorBorderMain);
});
export var WizardHeader = React.memo(function (_a) {
    var title = _a.title, description = _a.description;
    if (!title && !description) {
        return null;
    }
    return (React.createElement(TabPanelTitle, null,
        title || '',
        description && (React.createElement(View, { indentTop: INDENT.s },
            React.createElement(Text, { view: TEXT_VIEW.secondary }, description)))));
});
WizardHeader.displayName = 'WizardHeader';
var templateObject_1, templateObject_2;
//# sourceMappingURL=WizardHeader.js.map